import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/"
      }}>{`npm`}</a>{`'s concurrent script is great! Inspiredly today I just made yet another simple helper script that do similar things and keep everything simple (only bash shell).`}</p>
    <h1>{`Install`}</h1>
    <p>{`Just `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`ln`}</code>{` `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/experimental/.local/bin/simple_parallel"
      }}>{`this shell script`}</a>{` and expose it to your path e.g. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/usr/local/bin`}</code></p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` /usr/local/bin `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`ln`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-s`}</span>{` `}<span parentName="code" {...{
            "className": "token environment constant"
          }}>{`$HOME`}</span>{`/.dotfiles/misc/simple_parallel.sh simple_parallel `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&&`}</span>{` `}<span parentName="code" {...{
            "className": "token builtin class-name"
          }}>{`cd`}</span>{` -`}</code></pre></div>
    <h1>{`Example`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/169d522f290dca4ddfeabebf3899f7db/0b6f4/simple-parallel-example.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.666666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABp0lEQVQoz52Sy27UQBBFLUbOjDxjj/GrPX52+zEeFClSJBCPHYt8A1sEP4BYwRewYMGX8I03twrIgkQhYVFqtbrr1L2320s6i818Dt/OCN2IKfGxmABxGKAwBuMwoqlrNE2Dvuuw3W5RFAWSJEGWZUiLEnFmkBuu8R7espz08j6K0Pc98jzXfVXVKMtSqyZQYPs9Gzzv/lpOz9B1PekxrLUEFgQ0Ci3Lg66GSjebzb9hUtY5bRBb9e/qOaCqKtSEWetge6vqBd40LZwbMM9HHA4VgiDQYb7v/xp6okJpFmCWpZjmSaFhGN6oG4YBNe+0bQenLnJ1lKYpoQctyTRntt48TWjFIiFycFyOhJQauKUqaeqYX8M7hnnKkCgKFXjmn922XI0TdgTkhBlOmI+zZidAR7tPOdkxlpZWxaIoFvuyrlar28B3y4KPtPmcDQVVTuNABZFalijkZeWbiE39JlR8J+hPffg04Mv3ERcvQqSJfJVCIRL2g17173r/7Q2+/rzC5VWLeJfRTquPsl6v/w94+fIzXr39AVO/RpaGVLa7OUyfPB54DfL8CuT8oNO6AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Run simple_parallel",
            "title": "Run simple_parallel",
            "src": "/static/169d522f290dca4ddfeabebf3899f7db/0a47e/simple-parallel-example.png",
            "srcSet": ["/static/169d522f290dca4ddfeabebf3899f7db/8a4e8/simple-parallel-example.png 150w", "/static/169d522f290dca4ddfeabebf3899f7db/5a46d/simple-parallel-example.png 300w", "/static/169d522f290dca4ddfeabebf3899f7db/0a47e/simple-parallel-example.png 600w", "/static/169d522f290dca4ddfeabebf3899f7db/1cfc2/simple-parallel-example.png 900w", "/static/169d522f290dca4ddfeabebf3899f7db/0b6f4/simple-parallel-example.png 984w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Run simple_parallel`}</figcaption>{`
  `}</figure>
    <p>{`That's right, just type lines of command in your double quote input and it'll run each of them in parallel. This script only uses the most common commands found in *nix os and you can kill all the process using `}<kbd>{`ctrl`}</kbd>{`+`}<kbd>{`c`}</kbd></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      